<template lang="pug">
  .wrapper(:class="{ 'nav-open': $sidebar.showSidebar }")
    notifications
    side-bar
    .main-panel.custom-content
      TopNavbar
      dashboard-content
      content-footer
</template>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "@/pages/Layout/MobileMenu.vue";

export default {
  components: {
    TopNavbar,
    DashboardContent,
    ContentFooter,
    MobileMenu
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue